import { useState, useEffect } from 'react';
import { packSizeAPI } from '../services/api';

export const usePackSizes = () => {
  const [packSizes, setPackSizes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    loadPackSizes();
  }, []);

  const loadPackSizes = async () => {
    try {
      const data = await packSizeAPI.fetchPackSizes();
      setPackSizes(data);
    } catch (error) {
      setMessage({ type: 'error', text: 'Failed to load pack sizes' });
    } finally {
      setLoading(false);
    }
  };

  const updatePackSize = (index, newSize) => {
    const updated = [...packSizes];
    updated[index] = newSize;
    setPackSizes(updated);
    setMessage({ type: '', text: '' });
  };

  const addPackSize = () => {
    const newDefault = packSizes.length > 0 ? Math.min(...packSizes) + 1 : 1;
    setPackSizes([...packSizes, newDefault]);
    setMessage({ type: '', text: '' });
  };

  const removePackSize = (index) => {
    if (packSizes.length <= 1) {
      setMessage({ type: 'error', text: 'At least one pack size is required' });
      return false;
    }
    setPackSizes(packSizes.filter((_, i) => i !== index));
    setMessage({ type: '', text: '' });
    return true;
  };

  return {
    packSizes,
    loading,
    message,
    updatePackSize,
    addPackSize,
    removePackSize,
  };
};
